import React, { useContext } from "react";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ApprovalIcon from "@mui/icons-material/Approval";
import CancelIcon from "@mui/icons-material/Cancel";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { Box } from "@mui/material";
import CustomCard from "../../../../shared/CustomCard";
import { appContext } from "../../../../context/ContextProvider";

function Report() {
  const { user } = useContext(appContext);
  const reports = [
    {
      title: "PreAuth Report",
      icon: AssignmentIndIcon,
      path: "preauth/report/pre-auth",
    },
    {
      title: "Approved Report",
      icon: ApprovalIcon,
      path: "preauth/report/approved",
    },
    {
      title: "Rejected Report",
      icon: CancelIcon,
      path: "preauth/report/rejected",
    },
    {
      title: "Payer Wise Rejected Preauth with Percentage",
      icon: AnalyticsIcon,
      path: "preauth/report/impacts",
    },
  ];

  // Dummy RoleId for connect user
  if (user?.RoleId !== 6) {
    reports.push({
      title: "KPI",
      icon: AssessmentIcon,
      path: "preauth/report/kpi",
    });
  }

  return (
    <Box sx={{ p: 1 }}>
      <Box className=" grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {reports.map((report, index) => (
          <CustomCard
            key={index}
            title={report.title}
            icon={report.icon}
            path={report.path}
            color="#0070C2"
          />
        ))}
      </Box>
    </Box>
  );
}

export default Report;
